<style lang="sass">
@import "../../sass/base/_abbrev.scss";
.false-tip-wrap {
  /*position: absolute;*/
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background-color: #fff;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
//   display: -webkit-box;
//   display: box;
//   -webkit-box-align: center;
//   box-align: center;
//   -webkit-box-pack: center;
//   box-pack: center;
  height: 100%;
  padding: 0 10%;
//   -webkit-box-orient: vertical;
//   box-orient: vertical;
  color: #999;
  font-size: 0.48rem;
  box-sizing:border-box;
  z-index: 2;
  & .false-img-wrap{
    display:block;
    margin-bottom: rem(120);
    &>img{
      height: rem(275);
      margin:0 auto;
    }
  }
  &>.false-txt{
    @include fz(36);
    color:#999;
  }
 }
</style>
<script>
    export default {
       props:['tip'],
       data (){
            return {

            }
       },
       methods:{

       }
    }
</script>
<template >
    <div class="false-tip-wrap">
        <div class="false-img-wrap">
            <img  src="./dizzy.png"/>
        </div>
        <div class="false-txt">{{tip}}</div>
    </div>
</template>



// WEBPACK FOOTER //
// error.vue?4c056eae